import React from "react";

import { Box, Flex, Text } from "atoms";
import MemoTickIcon from "assets/icons/Tick";

const Circle = {
  TICK: (faded) => (
    <Flex
      w="2.8rem"
      h="2.8rem"
      bg={faded ? "neutral.100" : "primary.900"}
      color="white"
      bR="100%"
      aI="center"
      jC="center"
    >
      <MemoTickIcon height="2.4rem" />
    </Flex>
  ),

  UNVISITED: (
    <Flex
      w="2.8rem"
      h="2.8rem"
      bg="neutral.100"
      p="0.8rem"
      color="white"
      bR="100%"
      aI="center"
      jC="center"
    >
      <Box h="0.8rem" w="0.8rem" bR="100%" bg="white" />
    </Flex>
  ),

  PROGRESS: (faded) => (
    <Flex
      w="2.8rem"
      h="2.8rem"
      bg="#F2F4F7"
      p="0.8rem"
      color="white"
      bR="100%"
      aI="center"
      jC="center"
    >
      <Flex
        w="2.4rem"
        h="2.4rem"
        bg={faded ? "neutral.100" : "secondary.500"}
        p="0.8rem"
        color="white"
        bR="100%"
        aI="center"
        jC="center"
      >
        <Box h="0.8rem" w="0.8rem" bR="100%" bg="white" />
      </Flex>
    </Flex>
  ),
};
export const Stepper = ({ activeStep, steps, stepNavigate }) => {
  return (
    <Box>
      {steps.map((item, index) => (
        <Box key={index}>
          {index > 0 && (
            <Box
              h="1.8rem"
              w="0.2rem"
              bg={"neutral.200"}
              bR="2px"
              ml="1.3rem"
              my="0.4rem"
            />
          )}
          <Flex
            key={index}
            w="100%"
            aI="center"
            {...((item?.status ||
              (index
                ? steps?.[index - 1]?.status && !steps?.[index + 1]?.status
                : !item?.status)) && {
              cursor: "pointer",
              onClick: () => stepNavigate(index),
            })}
          >
            {item?.status
              ? Circle.TICK(index > activeStep)
              : (
                  index
                    ? steps?.[index - 1]?.status && !steps?.[index + 1]?.status
                    : !item?.status
                )
              ? Circle.PROGRESS(index > activeStep)
              : Circle.UNVISITED}

            <Text
              ml="1.2rem"
              color={
                activeStep === index
                  ? "secondary.700"
                  : item?.status
                  ? "neutral.800"
                  : (
                      index
                        ? steps?.[index - 1]?.status &&
                          !steps?.[index + 1]?.status
                        : !item?.status
                    )
                  ? "neutral.800"
                  : // ? "secondary.700"
                    "neutral.500"
              }
            >
              {item?.name}
            </Text>
          </Flex>
        </Box>
      ))}
      {/* {steps.map((item, index) => (
        <Box key={index}>
          {index > 0 && (
            <Box
              h="1.8rem"
              w="0.2rem"
              bg={steps?.[index - 1]?.status ? "primary.900" : "neutral.100"}
              bR="2px"
              ml="1.3rem"
              my="0.4rem"
            />
          )}
          <Flex
            key={index}
            w="100%"
            aI="center"
            {...((item?.status ||
              (index
                ? steps?.[index - 1]?.status && !steps?.[index + 1]?.status
                : !item?.status)) && {
              cursor: "pointer",
              onClick: () => stepNavigate(index),
            })}
          >
            {item?.status
              ? Circle.TICK
              : (
                  index
                    ? steps?.[index - 1]?.status && !steps?.[index + 1]?.status
                    : !item?.status
                )
              ? Circle.PROGRESS
              : Circle.UNVISITED}

            <Text
              ml="1.2rem"
              color={
                item?.status
                  ? "neutral.500"
                  : (
                      index
                        ? steps?.[index - 1]?.status &&
                          !steps?.[index + 1]?.status
                        : !item?.status
                    )
                  ? "secondary.700"
                  : "neutral.500"
              }
            >
              {item?.name}
            </Text>
          </Flex>
        </Box>
      ))} */}
    </Box>
  );
};
